import React, {useState} from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import Stepper from 'react-stepper-horizontal'
import DeviceForm from './forms/DeviceForm'
import CustomerForm from './forms/CustomerForm'
import * as rest from '../../services'
import IssueForm from './forms/IssueForm'
import { TicketUpdatePage } from './TicketUpdatePage'
import { showErrorToast, showSuccessToast } from '../../state/toasts'
import {Customer, Device, TicketPrint} from "../../api";
import {AxiosResponse} from "axios";

const NewTicketWizard = () => {
  const dispatch = useDispatch()
  const steps = ['Device', 'Customer', 'Issue', 'Print']
  const [currentStepIndex, setCurrentStepIndex] = useState(0)
  const [device, setDevice] = useState<Device>()
  const [customer, setCustomer] = useState<Customer>()
  const [selectedOrganization, setSelectedOrganization] = useState<string>()
  const [ticket, setTicket] = useState<TicketPrint>()


  const saveDevice = (deviceData:Device) => {
    if (!deviceData.serial_number) {
      deviceData.serial_number = deviceData.identifier
    }
    const promise = device
      ? new rest.DeviceService(device.url).makePutRequest(deviceData)
      : new rest.DeviceService().makePostRequest(deviceData)
    promise
      .then((response:AxiosResponse<Device>) => {
        setDevice(response)
        setCurrentStepIndex(currentStepIndex + 1)
      })
      .catch((errors) => {
        dispatch(
          showErrorToast(
            'Error Saving Device Info',
            JSON.stringify(errors.response ? errors.response.data : errors)
          )
        )
      })
  }
  const saveCustomer = (customerData) => {
    const promise = customer
      ? new rest.CustomerService(customer.url).makePutRequest(customerData)
      : new rest.CustomerService().makePostRequest(customerData)
    promise
      .then((response) => {
        setCustomer(response)
        setCurrentStepIndex(currentStepIndex + 1)
        setSelectedOrganization(customerData.organization)
        dispatch(showSuccessToast('Success', 'Customer Details have be saved.'))
      })
      .catch((errors) => {
        dispatch(
          showErrorToast(
            'Error Saving Customer Info',
            JSON.stringify(errors.response ? errors.response.data : errors)
          )
        )
      })
  }
  const saveTicket = (ticketData) => {
    const payload = {
      ...ticketData,
      ...{
        organization: selectedOrganization,
        device: device.url,
        customer: customer.url,
      },
    }
    const promise =
      ticket && ticket.url
        ? new rest.TicketService(ticket.url).makePutRequest(payload)
        : new rest.TicketService().makePostRequest(payload)
    promise
      .then((response) => {
        setTicket(response)
        setCurrentStepIndex(currentStepIndex + 1)
        dispatch(showSuccessToast('Success', 'Issue Details have be saved.'))
      })
      .catch((errors) => {
        dispatch(
          showErrorToast(
            'Error Saving Issue Info',
            JSON.stringify(errors.response ? errors.response.data : errors)
          )
        )
      })
  }

  return (
    <>
      <Stepper
        steps={steps}
        activeStep={currentStepIndex}
        activeColor="#1d2124"
        completeColor="green"
      />

      <div className={currentStepIndex !== 0 ? 'd-none' : 'd-block'}>
        <DeviceForm onSubmit={saveDevice}  />
      </div>

      <div className={currentStepIndex !== 1 ? 'd-none' : 'd-block'}>
        <CustomerForm onSubmit={saveCustomer} />
      </div>
      <div className={currentStepIndex !== 2 ? 'd-none' : 'd-block'}>
        <IssueForm onSubmit={saveTicket} organization={selectedOrganization} />
      </div>
      <div className={currentStepIndex !== 3 ? 'd-none' : 'd-block'}>
        <>
          {ticket && ticket.url && (

                <TicketUpdatePage
                  activeKey="jobsheet"
                  purchaseOrderNumber={ticket.reference_number}
                />

          )}
        </>
      </div>

      {currentStepIndex > 0 && (
        <ReactBootstrap.Button
          onClick={() => setCurrentStepIndex(currentStepIndex - 1)}
        >
          Previous
        </ReactBootstrap.Button>
      )}
    </>
  )
}

export default NewTicketWizard
